import { apiRequest } from '../../../../shared/http/transport.js';
export const exportBackup = () => apiRequest({ path: '/api/backup/export' });
export const importBackup = (body) => apiRequest({ path: '/api/backup/import', method: 'POST', body });
export const listMedia = () => apiRequest({ path: '/api/media' });
export const uploadMedia = (body) => apiRequest({ path: '/api/media', method: 'POST', body });
export const deleteMedia = (id) => apiRequest({ path: `/api/media/${id}`, method: 'DELETE' });
